// Redux/Constants/MessageConstants.js

// Create message
export const MESSAGE_CREATE_REQUEST = "MESSAGE_CREATE_REQUEST";
export const MESSAGE_CREATE_SUCCESS = "MESSAGE_CREATE_SUCCESS";
export const MESSAGE_CREATE_FAIL = "MESSAGE_CREATE_FAIL";
export const MESSAGE_CREATE_RESET = "MESSAGE_CREATE_RESET";

// Get user messages
export const MESSAGE_MY_LIST_REQUEST = "MESSAGE_MY_LIST_REQUEST";
export const MESSAGE_MY_LIST_SUCCESS = "MESSAGE_MY_LIST_SUCCESS";
export const MESSAGE_MY_LIST_FAIL = "MESSAGE_MY_LIST_FAIL";
export const MESSAGE_MY_LIST_RESET = "MESSAGE_MY_LIST_RESET";

// Delete message
export const MESSAGE_DELETE_REQUEST = "MESSAGE_DELETE_REQUEST";
export const MESSAGE_DELETE_SUCCESS = "MESSAGE_DELETE_SUCCESS";
export const MESSAGE_DELETE_FAIL = "MESSAGE_DELETE_FAIL";
export const MESSAGE_DELETE_RESET = "MESSAGE_DELETE_RESET";

// User reply to message
export const MESSAGE_REPLY_REQUEST = "MESSAGE_REPLY_REQUEST";
export const MESSAGE_REPLY_SUCCESS = "MESSAGE_REPLY_SUCCESS";
export const MESSAGE_REPLY_FAIL = "MESSAGE_REPLY_FAIL";
export const MESSAGE_REPLY_RESET = "MESSAGE_REPLY_RESET";

// Admin - List all messages
export const MESSAGE_LIST_REQUEST = "MESSAGE_LIST_REQUEST";
export const MESSAGE_LIST_SUCCESS = "MESSAGE_LIST_SUCCESS";
export const MESSAGE_LIST_FAIL = "MESSAGE_LIST_FAIL";
export const MESSAGE_LIST_RESET = "MESSAGE_LIST_RESET";

// Admin - Message stats
export const MESSAGE_STATS_REQUEST = "MESSAGE_STATS_REQUEST";
export const MESSAGE_STATS_SUCCESS = "MESSAGE_STATS_SUCCESS";
export const MESSAGE_STATS_FAIL = "MESSAGE_STATS_FAIL";

// Admin - Update message status
export const MESSAGE_STATUS_UPDATE_REQUEST = "MESSAGE_STATUS_UPDATE_REQUEST";
export const MESSAGE_STATUS_UPDATE_SUCCESS = "MESSAGE_STATUS_UPDATE_SUCCESS";
export const MESSAGE_STATUS_UPDATE_FAIL = "MESSAGE_STATUS_UPDATE_FAIL";
export const MESSAGE_STATUS_UPDATE_RESET = "MESSAGE_STATUS_UPDATE_RESET";